// extracted by css-extract-rspack-plugin
var _1 = "VbXNP";
var _2 = "fqEuY";
export { _1 as "hideScrollContainers", _2 as "mailListShimmerStateContainer" }
